import * as utils from '@/common/utils'

export const state = {
  simCardMode: '',
  assignSimCardMode: '',
  providerType: '',
  selectingProviderType: true,
  confirmUnassign: false,
  confirmDelete: false,
  simJustAdded: false,
  gdspoSimCardLoading: false,
  gdspoConfirmAssign: false
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @return Object
   */
  get (state) {
    return state
  }
}

export const actions = {
}

export const mutations = {
  /**
   * Resets the form's state.
   *
   * @param state      Object
   */
  reset (state) {
    state.simCardMode = ''
    state.assignSimCardMode = ''
    state.providerType = ''
    state.selectingProviderType = true
    state.confirmUnassign = false
    state.confirmDelete = false
    state.simJustAdded = false
    state.gdspoSimCardLoading = false
    state.gdspoConfirmAssign = false
  },

  /**
   * Sets a specific property and value
   *
   * @param state Object
   * @param name  String Name of property (supports "." dot notation)
   * @param value String
   * @param modifiesState Boolean
   */
  setProp (state, { name, value, modifiesState = true }) {
    if (modifiesState) {
      state.isModified = true
    }
    utils.mutateProp(state, name, value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/units/unitSimCardsModule.js